import React from 'react';
import game1 from "../assets/images/game-1.png";
import game2 from "../assets/images/game-2.png";
import game3 from "../assets/images/game-3.png";
import game4 from "../assets/images/game-4.png";

const AvailableGameSection = () => {
    return (
        <section id="available-game-section">
            <div class="overlay pb-120">
                <div class="container wow fadeInUp">
                    <div class="main-container">
                        <div class="row justify-content-between">
                            <div class="col-lg-10">
                                <div class="section-header">
                                    <h2 class="title">Available Games</h2>
                                    <p>We are constantly adding new games</p>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex items-center justify-between">
                            <div class="single-item">
                                <a href="#"><img src={game1} alt="" /></a>
                            </div>
                            <div class="single-item">
                                <a href="#"><img src={game2} alt="" /></a>
                            </div>
                            <div class="single-item">
                                <a href="#"><img src={game3} alt="" /></a>
                            </div>
                            <div class="single-item">
                                <a href="#"><img src={game4} alt="" /></a>
                            </div>
                        </div>
                        <div class="btn-area text-center">
                            <a href="tournaments.html" class="cmn-btn">View All</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default AvailableGameSection;